// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "Body {\n  margin: 0px;\n}\n\niframe#webpack-dev-server-client-overlay{display:none!important}\n", ""]);
// Exports
module.exports = exports;
